import { DelimitedTextFormatter } from 'field-kit';
export default class USPostalCodeFormatter extends DelimitedTextFormatter {
  constructor() {
    super('-', /* isLazy = */true);
    this.maximumLength = 10;
  }
  hasDelimiterAtIndex(index) {
    return index === 5;
  }
  format(str) {
    if (/\d{5}-\d{4}/.test(str)) {
      return super.format(str.replace(/-/, ''));
    }
    return super.format(str);
  }
  isChangeValid(change, error) {
    if (/^\d*$/.test(change.inserted.text)) {
      return super.isChangeValid(change, error);
    } else {
      return false;
    }
  }
}